import React, { useState } from 'react';
import { Button } from '@uhg-abyss/web/ui/Button';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { AppContext } from '@src/AppContext';
import { SortBy } from '../SortBy';
import { SidePane } from '../SidePane/SidePane';
import { styled } from '@uhg-abyss/web/tools/styled';

const Wrapper = styled('div', {
  '@media (min-width: 992px)': {
    display: 'block',
  },
  '@media (min-width: 1200px)': {
    display: 'none',
  },
});

const Tablet = styled('div', {
  marginTop: '40px',
  alignItems: 'end',
  display: 'none',

  '> div': {
    flexBasis: '50%',
  },

  '@media (min-width: 576px)': {
    display: 'flex',
  },

  '@media (min-width: 1200px)': {
    display: 'none',
  },
});

const TabletButtonMargin = styled('div', {
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginTop: 'auto',
  paddingBottom: '16px',

  '& button': {
    width: '100%',
  },
});

const MobileButtonMargin = styled('div', {
  textAlign: 'center',
  marginTop: '40px',

  '& button': {
    width: '339px',
  },
});

const Mobile = styled('div', {
  display: 'block',

  '@media (min-width: 576px)': {
    display: 'none',
  },
});

const FilterBtnWrap = styled('div', {
  width: '100%',
  display: 'flex',
  flexWrap: 'wrap',
  gap: '16px',
  marginTop: '16px',
});

const FilterBtn = styled('div', {
  minWidth: '30%',

  '& button': {
    width: '100%',

    '& i': {
      color: '#002677',
    },
  },
});

const ClearBtn = styled(Button, {
  minWidth: '30%',
  textDecoration: 'underline',

  '& button': {
    width: '100%',
    textDecoration: 'underline',
  },
});

export const TabletView = () => {
  const { filters = [], updateFilters } = React.useContext(AppContext);
  const [sideView, setSideView] = useState(false);
  const [showSort, setShowSort] = useState(false);
  const [oldFilters, setOldFilters] = useState([]);

  const clearFiltersHandler = () => {
    const k = filters.map((el) => {
      return { ...el, checked: false };
    });
    updateFilters(k);
  };

  const closeSidePane = () => {
    updateFilters(oldFilters);
    setSideView(false);
    clearFiltersHandler();
  };

  const openSidePane = (sort) => {
    if (sort === 'showSort') {
      setShowSort(true);
    } else {
      setShowSort(false);
    }
    setOldFilters(filters);
    setSideView(true);
  };

  const applyFilters = () => {
    setSideView(false);
  };

  const clearFilter = (el) => {
    const k = filters.map((m) => {
      return {
        ...m,
        checked: m.title === el.title ? false : m.checked,
      };
    });
    updateFilters(k);
  };

  return (
    <Wrapper>
      <SidePane
        closeSidePane={closeSidePane}
        applyFilters={applyFilters}
        sideView={sideView}
        showSort={showSort}
      />
      <Tablet>
        <TabletButtonMargin>
          <Button onClick={openSidePane}>Filter</Button>
        </TabletButtonMargin>
        <SortBy />
      </Tablet>
      <Mobile>
        <MobileButtonMargin>
          <Button
            onClick={() => {
              return openSidePane('showSort');
            }}
          >
            Filter and Sort
          </Button>
        </MobileButtonMargin>
      </Mobile>

      <FilterBtnWrap>
        {filters
          .filter((fl) => {
            return fl.checked;
          })
          .map((el) => {
            return (
              <FilterBtn>
                <Button
                  variant="outline"
                  after={<IconSymbol icon="close" isScreenReadable size={30} />}
                  onClick={() => {
                    return clearFilter(el);
                  }}
                >
                  {el.title}
                </Button>
              </FilterBtn>
            );
          })}
        {filters.filter((fl) => {
          return fl.checked;
        }).length ? (
          <ClearBtn variant="tertiary" onClick={clearFiltersHandler}>
            Clear Filters
          </ClearBtn>
        ) : null}
      </FilterBtnWrap>
    </Wrapper>
  );
};
